<template>
  <div>
    <div class="line_item" v-show="!multiple">
      <a href="javascript:void(0);" :data-id="item.id" v-for="(item, index) in arryData" :key="index" :class="item.id === id ? 'f_item active' : 'f_item'" @click="tagClick(item)">{{ item.name }}</a>
    </div>
    <div class="line_item" v-show="multiple">
      <a href="javascript:void(0);" :data-id="item.id" v-for="(item, index) in arryData" :key="index" :class="getMultiple(item)" @click="tagClick1(item)">{{ item.name }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    arryData: {
      type: Array,
      default() {
        return [];
      }
    },
    id: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    id(val) {
      this.value = val;
    },
    multipleList(list) {
      if (list.length === 0) {
        this.multipleList.push('');
      }
    }
  },
  data() {
    return {
      value: this.id,
      multipleList: [''],
      multiple_count: 2
    };
  },
  methods: {
    tagClick(item) {
      this.value = item.id;
      this.$emit('update:id', item.id);
      this.$emit('change', item.id, item);
    },
    tagClick1(item) {
      if (item.id === '') {
        //不限
        this.multipleList.length = 0;
      }
      const _index = this.multipleList.findIndex((v) => {
        return v === item.id;
      });
      if (_index === -1) {
        const _index1 = this.multipleList.findIndex((v) => {
          return v === '';
        });
        if (_index1 > -1) {
          this.multipleList.splice(_index1, 1);
        }
        if (this.multipleList.length >= this.multiple_count) {
          this.$message.warning(`最多选择${this.multiple_count}个`);
          return;
        }
        this.multipleList.push(item.id);
      } else {
        this.multipleList.splice(_index, 1);
      }
      this.value = this.multipleList.join(',');
      this.$emit('update:id', this.value);
      this.$emit('change', item.id, item);
    },
    getMultiple(item) {
      return this.multipleList.indexOf(item.id) > -1 ? 'active f_item' : 'f_item';
    }
  }
};
</script>

<style scoped>
.content {
  color: #333;
  display: block;
  overflow: hidden;
  line-height: 25px;
  font-size: 15px;
  margin-top: -1px;
}

.content .selected {
  color: #00a6a7;
  font-weight: 650;
}

.content a {
  margin-right: 2px;
  display: inline-block;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 400;
  color: #222;
}

.content a:hover {
  color: #00c48a !important;
}
.line_item .active {
  background-color: #f4fffc !important;
  color: #00c48a !important;
}

@media screen and (max-width: 768px) {
  .filter_combo .filter_line .line_item {
    width: 100% !important;
  }
}
</style>
